import { Component, computed, input, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { IEnergyRating, EnergyLabelComponent } from "src/app/shared-components/energy-label/energy-label.component";
import { IScoring, ScoringComponent } from "src/app/infopage/components/scoring/scoring.component";
import { LinkTaskbarComponent, LinkTaskbarSettings } from "./link-taskbar/link-taskbar.component";
import { ImageCarouselComponent } from "src/app/shared-components/image-carousel/image-carousel.component";
import { ImagePackage } from "src/models/common/image.model";
import { EvKeyValuePairModule } from "ev-key-value-pair";
import {
    KeyInfoPhysicalExposureComponent,
    IUnitTotalPhysicalExposures,
} from "../../components/key-info-physical-exposure/key-info-physical-exposure.component";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { OrganizationUnitKeyInfo } from "../../models/organization-unit-keyinfo.model";

@Component({
    selector: "key-info",
    templateUrl: "./key-info.component.html",
    styleUrl: "./key-info.component.scss",
    imports: [EnergyLabelComponent, ScoringComponent, LinkTaskbarComponent, ImageCarouselComponent, EvKeyValuePairModule, KeyInfoPhysicalExposureComponent],
})
export class KeyInfoComponent {
    private readonly authService = inject(EvAuthorizationService);

    keyInfoData = input.required<OrganizationUnitKeyInfo>();
    physicalExposures = input<IUnitTotalPhysicalExposures>();
    imagePackages = input<ImagePackage[]>([]);

    propertyImageClass = "borettslag";

    hasImages = computed(() => {
        return this.imagePackages().length > 0;
    });

    linkTaskbarSettings = computed<LinkTaskbarSettings>(() => {
        return {
            showViewInMap: this.keyInfoData()?.mapLatitude !== undefined && this.keyInfoData()?.mapLongitude !== undefined,
            showGetCadastreReport: false,
            showGetLandRegistrationReport: false,
        };
    });

    hasPhysicalExposuresRole = toSignal(this.authService.hasPermission(EVServiceType.EvWeb_PhysicalExposure));

    energyRating: IEnergyRating = {
        energyLabelPercentageShare: 33.3333333333,
        energyLabelMin: "G",
        energyLabelMax: "F",
        energyLabelMedian: "G",
        energyLabelColorMin: "Grønn",
        energyLabelColorMax: "Grønn",
        energyLabelColorMedian: "Grønn",
        energyColorClassMin: "g-green",
        energyColorClassMax: "f-green",
        energyColorClassMedian: "g-green",
        hasExpiredEnergyLabel: false,
        energyLabelsIsExpired: false,
    };
    score: IScoring = {
        areaMarketScoreMin: 3,
        areaMarketScoreMax: 5,
        areaMarketScore: 11,
        councilScore: 4,
    };

    protected goToPhysicalExposures() {
        //TODO: when accordion is in place
        //this.expandDetailsClicked.emit(AccordionIdentity.PhysicalRisk);
    }
}
